/**
 * Forbidden Page (403)
 *
 * Shown when user doesn't have access to a protected route.
 */

import React from "react";
import { ROUTES } from "@/router/routes";
import { AccessError } from "@/components/shared/AccessError";

export const ForbiddenPage: React.FC = () => {
  return (
    <AccessError
      code="403"
      message="Du har ikke tilgang til denne siden."
      homeUrl={ROUTES.BOOKING}
      homeLinkText="Til booking"
      data-testid="forbidden-page"
    />
  );
};

export default ForbiddenPage;
